import { Types } from './actions';

export const INITIAL_STATE = {
  cards: {
    active: {},
    provisional: {},
  },
};

export default function home(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.SET_CARDS_LIST:
      return {
        cards: {
          list: [...action.payload],
        },
      };
    case Types.SET_ACTIVE_TYPE:
      return {
        cards: {
          ...state.cards,
          active: action.payload,
        },
      };
    case Types.SET_PROVISIONAL_CARD:
      return {
        cards: {
          ...state.cards,
          provisional: action.payload,
        },
      };
    default:
      return state;
  }
}
